import { get, isEmpty } from 'lodash';

import clientCustomInputsService from '@services/clientCustomInputs';

import { formatNewItemsOfDropdownSelection } from '@commons/utils/format';

export const formatSupplierProductPayload = async (updatedSupplierProduct, clientId) => {
  const clientCustomInputs = await clientCustomInputsService.getClientCustomInputs();

  const supplierProductPayload = {
    supplierId: updatedSupplierProduct.supplier.id,
    conversions: updatedSupplierProduct.conversions,
    name: updatedSupplierProduct.name,
    sku: updatedSupplierProduct.sku === '' ? null : updatedSupplierProduct.sku,
    /**
     * When category or subCategory was/were updated in the form (SupplierProductInformations)
     * We need to get the updated values in updatedSupplierProduct.category and updatedSupplierProduct.subCategory
     * Otherwise, we can directly use the values from the supplierProduct object
     */
    categoryId: get(updatedSupplierProduct, 'category.id', updatedSupplierProduct.categoryId),
    subCategoryId: get(
      updatedSupplierProduct,
      'subCategory.id',
      updatedSupplierProduct.subCategoryId,
    ),
    entityId: isEmpty(updatedSupplierProduct.entity) ? null : updatedSupplierProduct.entity.id,
    loss: updatedSupplierProduct.loss === '' ? null : updatedSupplierProduct.loss,
    packagings: updatedSupplierProduct.packagings,
    vatRate: updatedSupplierProduct.vatRate === '' ? null : updatedSupplierProduct.vatRate,
    packagingUnit: updatedSupplierProduct.packagingUnit,
    packagingWeight:
      updatedSupplierProduct.packagingWeight === '' ? null : updatedSupplierProduct.packagingWeight,
    priceEditableAtReception: updatedSupplierProduct.priceEditableAtReception,
    // The numeric text input can leave the price as a string (e.g. "50"): the API compares it strictly with the stored price
    price:
      updatedSupplierProduct.price === '' || updatedSupplierProduct.price == null
        ? null
        : parseFloat(updatedSupplierProduct.price),
    shelfLife: updatedSupplierProduct.shelfLife === '' ? null : updatedSupplierProduct.shelfLife,
    manufacturerName: updatedSupplierProduct.manufacturerName,
    inventoryListTemplates: formatNewItemsOfDropdownSelection(
      updatedSupplierProduct.inventoryListTemplates,
    ),
    clientId,
    ean: updatedSupplierProduct.ean,
    allergens: updatedSupplierProduct.allergens,
    detailedComposition: updatedSupplierProduct.detailedComposition,
    nutritionFacts: updatedSupplierProduct.nutritionFacts,
  };

  if (
    updatedSupplierProduct.scheduledPriceValue >= 0 &&
    updatedSupplierProduct.scheduledPriceValue !== null &&
    !!updatedSupplierProduct.scheduledPriceDate
  ) {
    supplierProductPayload.scheduledPrice = {
      ...updatedSupplierProduct.scheduledPrice,
      price: updatedSupplierProduct.scheduledPriceValue,
      startDate: updatedSupplierProduct.scheduledPriceDate,
    };
  } else if (updatedSupplierProduct.scheduledPrice) {
    supplierProductPayload.scheduledPrice = updatedSupplierProduct.scheduledPrice;
  }

  const customPricesPayload = clientCustomInputs.reduce((res, { id }) => {
    if (!!updatedSupplierProduct[id]) {
      res.push({
        price: updatedSupplierProduct[id] === '' ? null : updatedSupplierProduct[id],
        clientCustomInputId: id,
      });
    }

    return res;
  }, []);

  return { supplierProductPayload, customPricesPayload };
};
